import React from 'react';
import { Ruler, Star, Truck } from 'lucide-react';
import ResumenSelecciones from './ResumenSelecciones';
import PagoOnline from './PagoOnline';
import { cop } from './tiendaUtils';

export default function CompraOnlineDetalle({ pedido, onActualizar }) {
  const c = pedido.compra_online;
  const pendiente = (pedido.saldo_pendiente || 0) > 0;
  return (
    <div className="space-y-4" data-testid={`compra-online-${pedido.numero}`}>
      <div>
        <p className="mb-2 text-xs uppercase tracking-wider text-zinc-500">Tu personalización · {c.producto_nombre}</p>
        <div className="rounded-xl bg-zinc-800/40 px-4 py-1">
          <ResumenSelecciones selecciones={c.selecciones || []} testId={`compra-online-selecciones-${pedido.numero}`} />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-2 text-sm sm:grid-cols-2">
        <p className="flex gap-2 rounded-xl bg-zinc-800/40 p-3 text-zinc-300"><Truck className="h-4 w-4 shrink-0 text-[#C9A962]" />
          <span>{c.envio?.titulo}{c.envio?.costo ? ` · ${c.envio.costo}` : ''}{c.envio?.direccion ? ` · ${c.envio.direccion}` : ''}</span>
        </p>
        <p className="flex gap-2 rounded-xl bg-zinc-800/40 p-3 text-zinc-300"><Ruler className="h-4 w-4 shrink-0 text-[#C9A962]" /><span>{c.medidas?.mensaje}</span></p>
        {c.puntos_usados > 0 && (
          <p className="flex gap-2 rounded-xl bg-zinc-800/40 p-3 text-zinc-300 sm:col-span-2"><Star className="h-4 w-4 shrink-0 text-[#C9A962]" />
            <span>Usaste {c.puntos_usados.toLocaleString('es-CO')} Puntos JPM: -{cop(c.descuento_puntos)} COP</span>
          </p>
        )}
      </div>
      {pendiente && (
        <PagoOnline ordenId={pedido.id} valor={c.pago.valor_a_pagar} enlace={c.pago.enlace} instrucciones={c.pago.instrucciones}
          reportePendiente={c.pago.reporte_pendiente} onReportado={onActualizar} />
      )}
    </div>
  );
}
